import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { LanguagesService } from "src/app/services/languagesService/languages.service";

@Component({
  selector: "app-content-detail",
  templateUrl: "./content-detail.page.html",
  styleUrls: ["./content-detail.page.scss"],
})
export class ContentDetailPage implements OnInit {
  type: string;
  id: string;
  new: any;

  constructor(
    private route: ActivatedRoute,
    public languageService: LanguagesService
  ) {}

  ngOnInit() {
    this.checkParam();
  }

  checkParam() {
    this.type = this.route.snapshot.paramMap.get("type");
    this.id = this.route.snapshot.paramMap.get("id");
  }

  get getTextsIUPageContent() {
    return this.languageService.textsIU.page_content;
  }
}
